import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import LegalistEdit from './LegalistEdit'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { HistoricType } from './FormalityProgressStatus'
import { FormalityResumeWrapper, ResumeLabel, ResumeValue } from './styles'
import { AbilityContext } from 'contexts/abilityContext'

const FormalityResume = () => {
  const { t } = useTranslation()
  const { legalFormality } = useContext(CurrentLegalFormalityContext)
  const ability: any = useContext(AbilityContext)

  const lastHistorics = legalFormality.lastStatusesHistorics || []

  const terminatedAt = () => {
    const terminatedHistoric = lastHistorics.find(
      (historic: HistoricType) => historic.final === 'legal_authority_validated'
    )
    return terminatedHistoric
      ? dayjs(terminatedHistoric.lastDate).format('DD/MM/YYYY')
      : '-'
  }

  const canReassign = ability.can('manage', 'LegalFormality')

  return (
    <FormalityResumeWrapper>
      {canReassign && (
        <li>
          <ResumeLabel>
            {t('legalFormalities:show.resume.labels.csm')}
          </ResumeLabel>
          <ResumeValue>
            <LegalistEdit />
          </ResumeValue>
        </li>
      )}
      <li>
        <ResumeLabel>
          {t('legalFormalities:show.resume.labels.form_provider')}
        </ResumeLabel>
        <ResumeValue>{legalFormality.formProvider}</ResumeValue>
      </li>
      <li>
        <ResumeLabel>
          {t('legalFormalities:show.resume.labels.created_at')}
        </ResumeLabel>
        <ResumeValue>
          {dayjs(legalFormality.createdAt).format('DD/MM/YYYY')}
        </ResumeValue>
      </li>
      <li>
        <ResumeLabel>
          {t('legalFormalities:show.resume.labels.finished_at')}
        </ResumeLabel>
        <ResumeValue>{terminatedAt()}</ResumeValue>
      </li>
    </FormalityResumeWrapper>
  )
}

export default FormalityResume
